import { render } from "./UndrawVoid.vue?vue&type=template&id=7afecf80"
import script from "./UndrawVoid.vue?vue&type=script&lang=js"
export * from "./UndrawVoid.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__